module.exports = __webpack_public_path__ + "media/images/calendar/april-5e83291b8bd92296c7adaedd508dc5f2.jpg";